import { getDatetimeText } from '@back-office/ui';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './UserDetail';

type RecurringPaymentDetailProps = {
  merchantName: string;
  billerAliasName: string;
  referenceNumber: string;
  sof: string;
  frequency: string;
  remindMeFlag: boolean;
  updatedBy: string;
  updatedAt: string;
};

const RecurringPaymentDetail: FC<RecurringPaymentDetailProps> = (props) => {
  const {
    merchantName,
    billerAliasName,
    referenceNumber,
    sof,
    frequency,
    remindMeFlag,
    updatedBy,
    updatedAt,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Typography className={classes.header}>
        {t('recurring_payment_detail.recurring_payment_details')}
      </Typography>
      <TableContainer>
        <Table aria-label="User Detail">
          <TableBody>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>{t('recurring_payment_detail.biller')}</Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography>{merchantName || '-'}</Typography>
              </TableCell>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.biller_alias')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography> {billerAliasName || '-'}</Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.reference_number')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} colSpan={3} width="75%">
                <Typography> {referenceNumber || '-'}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>{t('recurring_payment_detail.source')}</Typography>
              </TableCell>
              <TableCell className={classes.tableCell} colSpan={3} width="75%">
                <Typography>{sof || '-'}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.frequency')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography>{frequency || '-'}</Typography>
              </TableCell>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.remind_me_every')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography> {remindMeFlag ? 'on' : 'off'}</Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.updated_by')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography>{updatedBy || '-'}</Typography>
              </TableCell>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.updated_at')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography>
                  {' '}
                  {updatedAt ? getDatetimeText(updatedAt, 'longDate') : '-'}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default RecurringPaymentDetail;
